import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import routeConstants from "utils/routeConstants";

import { DesktopLink, MobileLink, ArrowCircle } from "./style";

type IrisLoginLinkProps = {
  variant: "desktop" | "mobile";
};

const IrisLoginLink: React.FC<IrisLoginLinkProps> = ({
  variant,
}: IrisLoginLinkProps) => {
  const LinkComponent = variant === "desktop" ? DesktopLink : MobileLink;

  return (
    <LinkComponent to={routeConstants.irisLogin} data-test-id="iris-login-link">
      <ArrowCircle>
        <FontAwesomeIcon icon={faArrowRight} />
      </ArrowCircle>
      Login to IRIS
    </LinkComponent>
  );
};

export default IrisLoginLink;
